<div class="page">
  <h1 class="title">{{ "general.items" | translate }}</h1>
  <div fxLayout="column">
    <form [formGroup]="itemForm" #itemFormRef="ngForm" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="start start" fxFlex="100">
      <div fxLayout="column" fxLayoutAlign="start center">
        <mat-card class="image-upload">
          <div class="image-container">
            @if(editItem.imagePath) {
              <ng-container>
                <img [src]="editItem.imagePath" alt="{{ 'item.image-alt' | translate }}" class="preview-image" />
              </ng-container>
            } @else {
              <ng-container>
                <mat-icon class="photo_camera">photo_camera</mat-icon>
              </ng-container>
            }
          </div>
          <label class="upload-button">
            <input #fileInput type="file" (change)="saveImage($event)" accept="image/*" hidden />
            <button mat-flat-button color="primary" (click)="triggerFileInput()">
              <mat-icon style="font-size: 13pt;">upload</mat-icon>
              <span style="font-size: 8pt;">{{ 'button.upload-image' | translate }}</span>
            </button>
          </label>
        </mat-card>
        <small class="upload-info">{{ 'button.max-size-message-5mb' | translate }}</small>
      </div>

      <div fxLayout="column" fxFlex="85">
        <div fxLayout="row" fxLayoutGap="16px">
          <mat-form-field fxFlex="20" appearance="outline">
            <mat-label>{{ 'general.partNumber' | translate }}</mat-label>
            <input formControlName="partNumber" name="partNumber" matInput />
          </mat-form-field>

          <mat-form-field fxFlex="80" appearance="outline">
            <mat-label>{{ 'general.item' | translate }}</mat-label>
            <input formControlName="item" name="item" matInput />
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
          <mat-form-field fxFlex="42" appearance="outline">
            <mat-label>{{ 'general.category' | translate }}</mat-label>
            <mat-select formControlName="category" name="category">
              @for (category of categories; track category) {
                <mat-option [value]="category"> {{ category.category }} </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex="42" appearance="outline">
            <mat-label>{{ 'general.manufacturer' | translate }}</mat-label>
            <input formControlName="manufacturer" name="manufacturer" matInput />
          </mat-form-field>

          <button mat-flat-button color="primary" class="add-button mg-b-22" [disabled]="!itemForm.valid" (click)="isEdit ? updateItem() : addItem()">
            {{ (isEdit ? "button.update" : "button.add") | translate }}
          </button>
        </div>
      </div>
    </form>

    <mat-form-field class="filter">
      <mat-label>{{ "general.filter" | translate }}</mat-label>
      <input matInput [formControl]="filter" #input>
    </mat-form-field>

    <div class="items-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="codItem">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 10%;">
            {{ 'general.codItem' | translate }}
          </th>
          <td mat-cell *matCellDef="let item"> {{ item.id }} </td>
        </ng-container>

        <ng-container matColumnDef="partNumber">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 10%;">
            {{ 'general.partNumber' | translate }}
          </th>
          <td mat-cell *matCellDef="let item"> {{ item.partNumber }} </td>
        </ng-container>

        <ng-container matColumnDef="item">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 30%;">
            {{ 'general.item' | translate }}
          </th>
          <td mat-cell *matCellDef="let item"> {{ item.description }} </td>
        </ng-container>

        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 20%;">
            {{ 'general.category' | translate }}
          </th>
          <td mat-cell *matCellDef="let item"> {{ item.category.category }} </td>
        </ng-container>

        <ng-container matColumnDef="manufacturer">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header" style="width: 20%;">
            {{ 'general.manufacturer' | translate }}
          </th>
          <td mat-cell *matCellDef="let item"> {{ item.manufacturer }} </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="table-header action" style="width: 10%;">
            {{ 'general.action' | translate }}
          </th>
          <td mat-cell *matCellDef="let item" class="action">
            <div class="action-buttons">
              <button mat-icon-button class="custom-red" (click)="deleteItem(item)">
                <mat-icon matTooltip="{{ 'button.delete-tooltip' | translate }}" style="color: #B41E2A;">
                  delete
                </mat-icon>
              </button>
              <button mat-icon-button (click)="startUpdate(item)">
                <mat-icon matTooltip="{{ 'button.edit-tooltip' | translate }}">
                  edit
                </mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
    <mat-paginator
      [length]="pageable.length"
      [pageSize]="pageable.pageSize"
      (page)="pageChange($event)"
      [pageSizeOptions]="[5, 10, 20]"
      [pageSize]="5"
      showFirstLastButtons>
    </mat-paginator>
  </div>
</div>
<app-breadcrumbs [breadcrumbsData]="breadcrumbsData"></app-breadcrumbs>
